import { InHouseInputSelectController } from './in-house-input-select.controller';
import { InHouseInputSelectProps } from './in-house-input-select.model';

export const InHouseInputSelect = (props: InHouseInputSelectProps) => {
  return <InHouseInputSelectController {...props} />;
};
